<template>
  <div class="modal_app" @click="closeDownAppModal">
    <div class="modal_contain">
      <div class="title">答疑权益请在app使用</div>
      <div class="guide"></div>
      <div class="bottom">
        <img src="https://image-prod.iqihang.com/project/ark-student-pc/img/appdown.7903a6ec.png" alt="" />
        <div class="text">请扫描二维码或在应用商店搜索"启航教育"</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeDownAppModal: {
      type: Function,
      default: () => { },
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../index.scss';
.modal_app {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .7);
  z-index: 110;
    .modal_contain {
    position: absolute;
    left: 50%;
    top: 50%;
    background-color: rgba(255, 255, 255, 1);
    transform: translate(-50%, -50%);
    border-radius: 36px;
    @include background(634px, 880px);
    background-size: 634px 297px;
    @include backgroundImage('member_down_bg.png');

  }
  .title {
    height: 45px;
    font-size: 33px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 45px;
    text-align: center;
    margin-top: 51px;
  }
  .guide {
    @include background(384px, 496px);
    @include backgroundImage('member_dayi_guide.png');
    margin: 71px 0 36px  149px;
  }
  .bottom {
    width: 634px;
    height: 181px;
    background: #F1F6FF;
    border-radius: 0px 0px 36px 36px;
    padding: 24px 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 134px;
      height: 134px;
    }
    .text {
      width: 346px;
      height: 72px;
      font-size: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
    }
  }
}

</style>
